import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { Label as TypoLabel } from "utils/styling/typography.styled";

export const ModalContainer = styled.div`
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
    border-radius: 0.5rem;
    max-width: 26rem;
    & > hr {
        width: 100%;
        color: ${colourScheme.white};
    }
`;

export const Label = styled(TypoLabel)`
    display: inline-flex;
    align-items: center;
    font-size: 1rem;
`;

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
    padding: 1rem 0rem;
    align-items: center;
    width: 100%;
    ${device.md} {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
`;

export const ToggleSwitch = styled.label`
    position: relative;
    display: inline-block;
    width: 3.5rem;
    height: 2rem;

    & input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${colourScheme.primary};
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 1.5rem;
        width: 1.5rem;
        left: 0.25rem;
        bottom: 0.25rem;
        background-color: ${colourScheme.white};
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }

    input:checked + .slider {
        background-color: ${colourScheme.secondary};
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(1.5rem);
        -ms-transform: translateX(1.5rem);
        transform: translateX(1.5rem);
    }

    .slider.round {
        border-radius: 1rem;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    input:disabled + .slider {
        filter: brightness(0.4);
    }
`;

export const FormGroup = styled.div`
    display: flex;
    align-items: stretch;
    flex-direction: column;
    ${device.md} {
        flex-direction: row;
    }
    ${device.lg} {
        flex-direction: column;
    }
    gap: 0.5rem;
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
`;

export const TextArea = styled.textarea`
    width: 100%;
    height: 10rem;
    padding: 1rem;
    border-radius: 0.25rem;
    border: 1px solid ${colourScheme.white};
    font-size: 1rem;
    resize: vertical;
`;

export const PremiumFormGroup = styled(FormGroup)`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const GoldCost = styled.span`
    color: gold;
    font-size: 0.9em;
    margin-left: 0.5rem;
`;
